import React, {useEffect, useState} from "react";
import {useHistory, useParams} from "react-router-dom";
import Nav from "./nav";
import Header from "./header_normal";
import {useDispatch, useSelector} from "react-redux";
import {getEmpleosNoAuth} from "../../redux/empleo";
import moment from "moment";

const ItemSection = () => {
    const {id} = useParams();
    const dispatch = useDispatch();
    let history = useHistory();

    useEffect(() => {
        dispatch(getEmpleosNoAuth("", ""));
    }, [dispatch]);

    const empleos = useSelector((store) => store.oft.empleos);

    const [data, setData] = useState({
        id_oferta_empleo: 0,
        estado: {
            id_estado: 0,
            descripcion: ''
        },
        fecha_creacion: '',
        fecha_modificacion: '',
        fecha_publicacion: '',
        fecha_caducidad: '',
        cargo: '',
        descripcion: '',
        ciudad: '',
        empresa: '',
        modalidad: '',
        requisitos: '',
        beneficios: '',
        habilidades: '',
        oferta: '',
        usuario_creador: 0,
        usuario_modificador: 0,
        estado_id: 0
    })

    useEffect(() => {
        if (empleos) {
            let value = empleos.filter(item => parseInt(item.id_oferta_empleo) === parseInt(id));
            if (value.length > 0) {
                setData(value[0]);
            }
        }
    }, [empleos, id]);

    const time = (date) => {
        moment().locale('es');
        return moment(date, "YYYY-MM-DD hh:mm:ss").fromNow();
    }

    return (
        <>
            <Nav/>
            <Header/>
            <section className="job-header">
                <div className="container">
                    <h2>{data.cargo}</h2>
                </div>
            </section>
            <section className="job-content">
                <div className="container">
                    <div className="row g-5">
                        <div className="col-lg-8">
                            <div className="d-flex align-items-center mb-4">
                                <div className="job-logo">
                                    <img src="assets/img/ISOTIPO.png" alt="Logo"/>
                                </div>
                                <div className="job-company"><h5>{data.empresa}</h5></div>
                            </div>

                            <p style={{fontSize: 16}}><strong>{data.cargo}</strong> en <strong>{data.empresa}</strong>, {data.ciudad}</p>

                            <div className="job-description">
                                <h5>Principales tareas y responsabilidades:</h5>
                                <p style={{fontSize: 16}}>{data.descripcion}</p>

                                <h5 style={{fontSize: 16}}>Requisitos:</h5>
                                <p style={{fontSize: 16}}>{data.requisitos}</p>

                                <h5 style={{fontSize: 16}}>Beneficios:</h5>
                                <p style={{fontSize: 16}}>{data.beneficios}</p>

                                <h5 style={{fontSize: 16}}>Principales habilidades:</h5>
                                <p style={{fontSize: 16}}>{data.habilidades}</p>
                            </div>
                        </div>

                        <div className="col-lg-4">
                            <div className="sidebar-card">
                                <h6>Vista general de empleo</h6>
                                {data.fecha_publicacion &&
                                    <div className="info-item">
                                        <i className="bi bi-calendar3"></i>
                                        <div><strong>Fecha de publicación:</strong><br/>{time(data.fecha_publicacion)}</div>
                                    </div>
                                }
                                {data.fecha_caducidad &&
                                    <div className="info-item">
                                        <i className="bi bi-calendar-event"></i>
                                        <div><strong>Fecha de vencimiento:</strong><br/>{time(data.fecha_caducidad)}</div>
                                    </div>
                                }
                                <div className="info-item">
                                    <i className="bi bi-geo-alt"></i>
                                    <div><strong>Ubicación:</strong><br/>{data.ciudad}</div>
                                </div>

                                <div className="info-item">
                                    <i className="bi bi-briefcase"></i>
                                    <div><strong>Nombre del cargo:</strong><br/>{data.cargo}</div>
                                </div>

                                <div className="info-item">
                                    <i className="bi bi-people"></i>
                                    <div><strong>Modalidad:</strong><br/>{data.modalidad}</div>
                                </div>

                                <button className="btn-apply mt-3" onClick={() => {history.push(`/postulacion/${id}`)}}>Postularme</button>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default ItemSection;